import {DashboardTemplateConfig} from "../../../../../core/gd-modules/dashboard/templates/templates-custom"
import {ViewType} from "../../../../../core/gd/const/views/view-type"
import ApiProject from "../../../../../core/gd/api/project"
import {DashboardType} from "../../../../../core/gd-modules/dashboard/model/dashboard/types"
import Template from "../../../../../core/model2/template/template";

// const debug = "createCustomDashboard"
const debug = false

export async function createCustomDashboardFromTemplate(template: Template, creationParams: any = {}) {

    const params = {
        location    : _.get(creationParams, 'location', 'my-work'),
        ...creationParams
    }

    const settings: any = {
        dashboardType   : template.dashboardType,
        appSettings     : {} // backemd handle it
    }

    switch (settings.dashboardType) {
        case DashboardType.PROJECT:
            settings.projectId = params.parentProjectId
            break
    }

    debug && console.log(debug, 'process', params)

    let response: any
    if (params.parentProjectId) {
        const parentProject = gd.session.projects.get(params.parentProjectId)!
        response = await ApiProject.newView({
            name            : template.name,
            color           : parentProject.color,
            parentProjectId : params.parentProjectId,
            projectIcon     : 'view-dashboard',
            templateId      : template.publicId,
            settings        : {
                customView      : {
                    settings        : {}, // backend will handle it
                    type            : ViewType.CUSTOM_VIEW_DASHBOARD
                }
            }
        }).promise()

        gd.navigation.goToProject(response.projectId)
    } else {
        response = await gd.api.Views.create(
            ViewType.CUSTOM_VIEW_DASHBOARD,
            template.name,
            params,
            0,
            null,
            settings,
            template.publicId
        ).promise()

        gd.navigation.goToDashboard(response.view.id)
    }


}